module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-8-zoom.a2051642.png";